import { render, staticRenderFns } from "./MyProfileView.vue?vue&type=template&id=ec1df20a&"
import script from "./MyProfileView.vue?vue&type=script&lang=js&"
export * from "./MyProfileView.vue?vue&type=script&lang=js&"
import style0 from "./MyProfileView.vue?vue&type=style&index=0&id=ec1df20a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports